
import React from "react";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import PilotApplicationForm from "./PilotApplicationForm";

interface PilotApplicationDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onFormSubmitted?: () => void;
}

export function PilotApplicationDialog({
  open,
  onOpenChange,
  onFormSubmitted,
}: PilotApplicationDialogProps) {
  const handleFormClose = () => {
    onOpenChange(false);
  };
  
  const handleFormSubmit = () => {
    if (onFormSubmitted) {
      onFormSubmitted();
    }
    onOpenChange(false);
  };
  
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-[600px] md:max-w-[700px] max-h-[90vh] overflow-y-auto">
        <DialogHeader>
          <DialogTitle className="sr-only">Pilot Application Form</DialogTitle>
        </DialogHeader>
        <PilotApplicationForm 
          onClose={handleFormClose} 
          onSubmitSuccess={handleFormSubmit}
        />
      </DialogContent>
    </Dialog>
  );
}

export default PilotApplicationDialog;
